export const SMART_LISTS = [{
    id: null,
    name: "All" 
   },{
    id: "owned_by_me",
    name: "Owned by me"
 }];